import { render, staticRenderFns } from "./PaperPreview.vue?vue&type=template&id=e3ce891c&scoped=true"
import script from "./PaperPreview.vue?vue&type=script&lang=js"
export * from "./PaperPreview.vue?vue&type=script&lang=js"
import style0 from "./PaperPreview.vue?vue&type=style&index=0&id=e3ce891c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ce891c",
  null
  
)

export default component.exports